/**
 * useProfile - Get the current LanguageProfile based on user settings
 */

import { useMemo } from 'react'
import { getProfile } from '@shared/languages'
import { useSettings } from './useSettings'

export function useProfile() {
  const { languagePair } = useSettings()
  return useMemo(() => getProfile(languagePair), [languagePair])
}
